<template>
  <div v-if="this.internetInboundUtilisationSeries.length > 0 || this.internetOutboundUtilisationSeries > 0">
    <Chart :options="chartOptions"/>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import {Chart} from 'highcharts-vue';
  import {HIGHCHARTS_DEFAULTS} from '../../constants';

  export default {
    name: "NetworkTrafficInternet",
    components: {
      Chart,
    },
    props: ['sitecode', 'dateRange',],
    mounted() {
      this.fetchBUDMetricsInternet({siteCode: this.sitecode, dateRange: this.dateRange});
      this.fetchBUDBandwidth({siteCode: this.sitecode});
    },
    computed: {
      ...mapGetters(['internetInboundUtilisationSeries', 'internetOutboundUtilisationSeries','bandwidthIntCap']),
      chartOptions() {
        return Object.assign({}, HIGHCHARTS_DEFAULTS, {
          chart: {
            type: 'area',
            zoomType: 'x',
          },
          title: {
            text: '<b>Internet@Edge</b>'+ (this.bandwidthIntCap ? '<b> - Bandwidth Cap: '+ this.bandwidthIntCap +' Mbps</b>': ''),
            style: {
              color: '#041E42',
            }
          },
          subtitle: {
            text: document.ontouchstart === undefined ?
              'Click and drag in the plot area to zoom in' : 'Pinch the chart to zoom in'
          },
          xAxis: {
            type: 'datetime'
          },
          yAxis: {
            title: {
              enabled: true,
              text: 'Bandwidth (Mbps)',
            },
            labels: {
              formatter: function () {
                return this.value + ' Mbps';
              }
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size: 10px">{point.key:%H:%M - %d/%m/%Y}</span><br/>',
            pointFormat: '{point.y:,.4f} Mbps'
          },
          legend: {
            enabled: true,
          },
          plotOptions: {
              series: {
                  turboThreshold: 3500,
              },
          },
          series: [{
            name: 'Downloads',
            data: this.internetInboundUtilisationSeries,
            color: '#1D428A'
          }, {
            name: 'Uploads',
            data: this.internetOutboundUtilisationSeries,
            color: '#6BACE4'
          }],
        });
      }
    },
    methods: {
      ...mapActions(['fetchBUDMetricsInternet','fetchBUDBandwidth'])
    },
    watch: {
      sitecode: function () {
        this.fetchBUDMetricsInternet({siteCode: this.sitecode, dateRange: this.dateRange});
        this.fetchBUDBandwidth({siteCode: this.sitecode});
      },
      dateRange: function () {
        this.fetchBUDMetricsInternet({siteCode: this.sitecode, dateRange: this.dateRange});
      }
    }
  }
</script>

<style scoped>

</style>
